import { render, staticRenderFns } from "./SkillHistoryByStudent.vue?vue&type=template&id=a6982234&scoped=true"
import script from "./SkillHistoryByStudent.vue?vue&type=script&lang=js"
export * from "./SkillHistoryByStudent.vue?vue&type=script&lang=js"
import style0 from "./SkillHistoryByStudent.vue?vue&type=style&index=0&id=a6982234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6982234",
  null
  
)

export default component.exports